import { makeVar } from '@apollo/client'

import { RouteWithAccessType } from '../staticRoleManagement/types'
import { Credentials } from '../types/auth'

export const credentialsVar = makeVar<Credentials | undefined>(undefined)
export const loadingSessionStorage = makeVar<boolean>(true)

export const getCredentials = (): Credentials | undefined => {
  return credentialsVar()
}

export function buildFeatureSet(credentials?: Credentials): Set<string> {
  return new Set(credentials?.features?.map((f) => f.name) ?? [])
}

export function hasRequiredFeatures(
  requiredFeatures: string[] | undefined,
  featureSet: Set<string>
): boolean {
  if (!requiredFeatures || requiredFeatures.length === 0) {
    return true // no restriction → allow TODOTODO
  }

  return requiredFeatures.every((feature) => featureSet.has(feature))
}

export function canAccessRoute(
  route: RouteWithAccessType,
  featureSet: Set<string>
): boolean {
  if (route.requiredFeatures?.length === 0) return true

  return hasRequiredFeatures(route.requiredFeatures, featureSet)
}

export function canAccessTab(
  routeConfig: RouteWithAccessType | undefined,
  tabValue: string,
  featureSet: Set<string>
): boolean {
  const tabConfig = routeConfig?.tabs?.find(
    (tab) => tab.params.page === tabValue
  )

  if (!tabConfig) return false

  return hasRequiredFeatures(tabConfig?.requiredFeatures, featureSet)
}

export function canAccessByRoutePath(
  routePath: string,
  featureSet: Set<string>,
  roleManagementArray: RouteWithAccessType[]
): boolean {
  const routeConfig = roleManagementArray.find(
    (item) => item.route === routePath
  )

  if (!routeConfig) return false

  if (routeConfig.requiredFeatures?.length === 0) return true

  return hasRequiredFeatures(routeConfig.requiredFeatures, featureSet)
}
